module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-01-5f1cc215c6b11950c0ff955afe30d15a.jpg";